import React from "react";
import Col from "react-bootstrap/Col";

import { NavLink } from "react-router-dom";
import { PALETTE } from "../ThemeConstants";

export default function CustomIconTab({
  image,
  imageHovered,
  imageActive,
  to,
  text = "",
  width = 50,
  notify = false,
  px = true,
  onClick = () => { }
}) {
  const onMouseEnter = (e, isActive) => {
    if (isActive && to !== "") {
      return;
    }
    e.currentTarget.children[0].src = imageHovered;
    e.currentTarget.children[2].style.color = PALETTE.SECONDARYCOLORKINDALIGHT;
  };

  const onMouseLeave = (e, isActive) => {
    if (isActive && to !== "") {
      return;
    }
    e.currentTarget.children[0].src = image;
    e.currentTarget.children[2].style.color = PALETTE.TRUEGRAY;
  };

  return (
    <Col className={`text-center align-self-center py-1 ${!px && "px-0"}`} style={{ cursor: "pointer" }} onClick={onClick}>
      <NavLink to={to} style={{ textDecoration: "none" }}>
        {({ isActive }) => (
          <div
            onMouseEnter={(e) => onMouseEnter(e, isActive)}
            onMouseLeave={(e) => onMouseLeave(e, isActive)}
          >
            <img
              src={isActive && to !== "" ? imageActive : image}
              width={width}
              alt={text}
            />
            {notify && (
              <div
                className="badge rounded-pill blink"
                style={{
                  width: 16,
                  height: 16,
                  marginLeft: -8,
                  marginTop: -4,
                  position: "absolute",
                  background: PALETTE.LINEARGRADIENT,
                  border: "solid 1px " + PALETTE.LIGHTGRAY,
                }}
              />
            )}
            <br />
            <span
              style={{
                fontSize: "12px",
                color: isActive && to !== ""
                  ? PALETTE.SECONDARYCOLORKINDALIGHT
                  : PALETTE.TRUEGRAY,
              }}
            >
              {text}
            </span>
          </div>
        )}
      </NavLink>
    </Col>
  );
}
